import React, { Fragment, useState, useEffect, useRef } from "react";
import Header from "../common/header";
import Footer from "../common/footer";
import AboutBanner from "./about-banner";
import AboutInvesting from "./about-investing";
import AboutAmenities from "./about-amenities";
import AboutIdentity from "./about-identity";
import AboutWhyMarquis from "./about-why-marquis";
import AboutVisionMision from "./about-vision-mision";
import AboutParallax from "./about-parallax";
import { useLocation } from "react-router-dom";
import { fetchAboutPageData } from "./fetchAboutPageData";
import logo from "../../assets/marquis-logo.svg";
import * as apiUrl from "../../apiUrl";

function AboutPage() {
  const [pageData, setPageData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  const sectionRefs = useRef({
    "investing-in-dubai": null,
    "our-identity": null,
    "our-mission": null,
    "why-marquis": null,
  });

  const location = useLocation();

  // Function to preload images
  const preloadImages = async (imageUrls) => {
    const promises = imageUrls.map((url) => {
      return new Promise((resolve, reject) => {
        const img = new Image();
        img.src = url;

        img.onload = () => resolve(url); 
        img.onerror = (error) => {
          console.error(`Failed to load image: ${url}`, error); 
          reject(error); 
        };
      });
    });

    try {
      await Promise.all(promises); 
      setIsLoading(false);     
    } catch (error) {
      console.error("Error preloading some images:", error);
    }
  }; 

  useEffect(() => {
    const loadPageData = async () => {
      try {
        const data = await fetchAboutPageData();
        setPageData(data); // Set page data after preloading

        const amenityData =
          data.amenities && typeof data.amenities.amenities === "string"
            ? JSON.parse(data.amenities.amenities)
            : [];

        const amenityImages = amenityData.map((amenity) => amenity.image);

        if (data) {
          // Extract and prepare image URLs for preloading
          const imageUrls = [
            data.banner.banner_image,
            ...amenityImages, 
            data.investing.first_image,
            data.identity.section_image,
            data.whyMarquis.first_image,
            data.whyMarquis.second_image,
            data.visionMission.mission_image,
            data.visionMission.vision_image,
            data.parallax.last_image,
          ]
            .filter(Boolean)
            .map((image) => `${apiUrl.apiUrl}/${image}`);

          // Render page content first, then preload images
         
          preloadImages(imageUrls); 
           
        }
      } catch (error) {
        console.error("Error loading page data or images:", error);
        setIsLoading(false); 
      }
    };

    loadPageData();
  }, []);

  // Scroll to the section when the hash changes
  useEffect(() => {
    const hash = location.hash.replace("#", ""); // Get the hash without the `#`
    if (hash && sectionRefs.current[hash]) {
      sectionRefs.current[hash].scrollIntoView({
        behavior: "smooth",
        block: "end",
      });
    }
  }, [location.hash]);

  if (isLoading) {
    return (
      <div className="loading-container">
        <img src={logo} alt="Loading" className="loading-logo" />
      </div>
    );
  }

  return (
    <Fragment>
      <Header />
      <AboutBanner data={pageData.banner} />
        <AboutWhyMarquis
        data={pageData.whyMarquis}
        id="why-marquis"
        scrollToSection={() =>
          sectionRefs.current["why-marquis"]?.scrollIntoView({
            behavior: "smooth",
            block: "start",
          })
        }
      />
       <AboutIdentity
        data={pageData.identity}
        id="our-identity"
        scrollToSection={() =>
          sectionRefs.current["our-identity"]?.scrollIntoView({
            behavior: "smooth",
            block: "start",
          })
        }
      />
      <AboutVisionMision
        data={pageData.visionMission}
        id="our-mission"
        scrollToSection={() =>
          sectionRefs.current["our-mission"]?.scrollIntoView({
            behavior: "smooth",
            block: "start",
          })
        }
      />
      <AboutInvesting
        data={pageData.investing}
        id="investing-in-dubai"
        scrollToSection={() =>
          sectionRefs.current["investing-in-dubai"]?.scrollIntoView({
            behavior: "smooth",
            block: "start",
          })
        }
      />
      <AboutAmenities data={pageData.amenities} />
    
     
      <AboutParallax data={pageData.parallax} />
      <Footer />
    </Fragment>
  );
}

export default AboutPage;

// import React, { Fragment, useState, useEffect, useRef } from "react";
// import Header from "../common/header";
// import Footer from "../common/footer";
// import AboutBanner from "./about-banner";
// import AboutInvesting from "./about-investing";
// import AboutAmenities from "./about-amenities";
// import AboutIdentity from "./about-identity";
// import AboutWhyMarquis from "./about-why-marquis";
// import AboutVisionMision from "./about-vision-mision";
// import AboutParallax from "./about-parallax";
// import { useLocation } from "react-router-dom";
// import { fetchAboutPageData } from "./fetchAboutPageData";
// import logo from "../../assets/Marquis-Developers-Logo-SVG.svg";
// import * as apiUrl from "../../apiUrl";

// function AboutPage() {
//   const [pageData, setPageData] = useState(null);
//   const [isLoading, setIsLoading] = useState(true);
//   const sectionRefs = useRef({
//     "investing-in-dubai": null,
//     "our-identity": null,
//     "our-mission": null,
//     "why-marquis": null,
//   });

//   const location = useLocation();

//   // Helper: Preload images with promise resolution
//   const preloadImages = (imageUrls) => {
//     const promises = imageUrls.map(
//       (url) =>
//         new Promise((resolve) => {
//           const img = new Image();
//           img.src = url;
//           img.onload = resolve;
//           img.onerror = resolve;
//         })
//     );
//     return Promise.all(promises);
//   };

//   useEffect(() => {
//     const loadPageData = async () => {
//       try {
//         const data = await fetchAboutPageData();
//         setPageData(data);

//         const amenityData =
//           data.amenities && typeof data.amenities.amenities === "string"
//             ? JSON.parse(data.amenities.amenities)
//             : [];

//         const amenityImages = amenityData.map((amenity) => amenity.image);

//         if (data) {
//           const imageUrls = [
//             data.banner.banner_image,
//             ...amenityImages,
//             data.investing.first_image,
//             data.identity.section_image,
//             data.whyMarquis.first_image,
//             data.whyMarquis.second_image,
//             data.visionMission.mission_image,
//             data.visionMission.vision_image,
//             data.parallax.last_image,
//           ]
//             .filter(Boolean)
//             .map((image) => `${apiUrl.apiUrl}/${image}`);

//           await preloadImages(imageUrls); // Preload images
//         }
//         setIsLoading(false); // Render page
//       } catch (error) {
//         console.error("Error loading page data or images:", error);
//         setIsLoading(false);
//       }
//     };

//     loadPageData();
//   }, []);

//   // Scroll to the section after layout stabilizes
//   useEffect(() => {
//     const scrollToSection = () => {
//       const hash = location.hash.replace("#", "");
//       if (hash && sectionRefs.current[hash]) {
//         sectionRefs.current[hash].scrollIntoView({
//           behavior: "smooth",
//           block: "start",
//         });
//       }
//     };

//     if (!isLoading) {
//       scrollToSection();

//       // Observe layout changes and re-scroll if necessary
//       const observer = new ResizeObserver(() => {
//         scrollToSection();
//       });
//       Object.values(sectionRefs.current).forEach((ref) => {
//         if (ref) observer.observe(ref);
//       });

//       return () => observer.disconnect();
//     }
//   }, [location.hash, isLoading]);

//   if (isLoading) {
//     return (
//       <div className="loading-container">
//         <img src={logo} alt="Loading" className="loading-logo" />
//       </div>
//     );
//   }

//   return (
//     <Fragment>
//       <Header />
//       <AboutBanner data={pageData.banner} />
//       <AboutInvesting
//         data={pageData.investing}
//         id="investing-in-dubai"
//         scrollToSection={() =>
//           sectionRefs.current["investing-in-dubai"]?.scrollIntoView({
//             behavior: "smooth",
//             block: "start",
//           })
//         }
//       />
//       <AboutAmenities data={pageData.amenities} />
//       <AboutWhyMarquis
//         data={pageData.whyMarquis}
//         id="why-marquis"
//         scrollToSection={() =>
//           sectionRefs.current["why-marquis"]?.scrollIntoView({
//             behavior: "smooth",
//             block: "start",
//           })
//         }
//       />
//       <AboutIdentity
//         data={pageData.identity}
//         id="our-identity"
//         scrollToSection={() =>
//           sectionRefs.current["our-identity"]?.scrollIntoView({
//             behavior: "smooth",
//             block: "start",
//           })
//         }
//       />
//       <AboutVisionMision
//         data={pageData.visionMission}
//         id="our-mission"
//         scrollToSection={() =>
//           sectionRefs.current["our-mission"]?.scrollIntoView({
//             behavior: "smooth",
//             block: "start",
//           })
//         }
//       />
//       <AboutParallax data={pageData.parallax} />
//       <Footer />
//     </Fragment>
//   );
// }

// export default AboutPage;


